import { useState, useEffect } from "react";
import { useAppDispatch } from "./redux/hooks";
import { setDocuments, createDocument } from "./redux/documentsSlice";
import { DocumentList } from "./components/DocumentList";
import { Editor } from "./components/Editor";
import { Preview } from "./components/Preview";
import { SearchBar } from "./components/SearchBar";
import { ThemeChanger } from "./components/ThemeChanger";

function App() {
  const dispatch = useAppDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const savedDocs = localStorage.getItem("markdown-docs");
    if (savedDocs) {
      dispatch(setDocuments(JSON.parse(savedDocs)));
    }
  }, [dispatch]);

  return (
    <div className="h-screen flex flex-col">
      <header className="flex items-center justify-between p-4 bg-gray-100">
        <button
          onClick={() => dispatch(createDocument())}
          className="bg-blue-500 text-white px-4 py-2 rounded w-1/6"
        >
          Create New
        </button>
        <SearchBar onSearch={setSearchTerm} />
        <ThemeChanger />
      </header>
      <div className="flex flex-1 overflow-hidden">
        <aside className="w-1/5 border-r overflow-y-auto flex flex-col items-center">
          <span className="px-2 py-4 font-bold">Document List</span>
          <DocumentList searchTerm={searchTerm} />
        </aside>
        <main className="w-2/5 overflow-hidden">
          <Editor />
        </main>
        <section className="w-2/5 overflow-hidden">
          <Preview />
        </section>
      </div>
    </div>
  );
}

export default App;